module.exports = __webpack_public_path__ + "img/img-001fa1.png";